import axios from "../axios";
import {
    ADD_DELIVERY_ADDRESS_API,
    GET_DELIVERY_ADDRESS_API,
    UPDATE_DELIVERY_ADDRESS_API,
    DELETE_DELIVERY_ADDRESS_API,

} from "../../global/ApiUrl";


export const addDeliveryAddressAPI = async (payload) => {
    try {
        const response = await axios.post(ADD_DELIVERY_ADDRESS_API, payload);
        return response;
    } catch (error) {
        await console.log("catch error in addDeliverAddressAPI", error);
        return error;
    }
};

export const getDeliveryAddressAPI = async (email) => {
    try {
        const response = await axios.get(GET_DELIVERY_ADDRESS_API, {
            params: {
                email: email,
            }
        });
        return response;
    } catch (error) {
        await console.log("catch error in getDeliverAddressAPI", error);
        return error;
    }
};

export const updateDeliveryAddressAPI = async (payload) => {
    try {
        const response = await axios.put(UPDATE_DELIVERY_ADDRESS_API, payload);
        return response;
    } catch (error) {
        await console.log("catch error in updateDeliverAddressAPI", error);
        return error;
    }
};


export const deleteDeliveryAddressAPI = async (payload) => {
    try {
        const response = await axios.patch(DELETE_DELIVERY_ADDRESS_API, payload);
        return response;
    } catch (error) {
        await console.log("catch error in deleteDeliverAddressAPI", error);
        return error;
    }
};